import { getThumbnailImage } from '@/utils/media';
import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

const styles = {
  src: {
    borderRadius: '4px',
  },
};

interface MediaProps {
  title?: string;
  size?: string;
  src: string;
}

const MediaContent = ({ title, size, src }: MediaProps) => {
  const { organizationId, templateId } = useParams<{ organizationId?: string; templateId?: string; }>();
  
  const imageUrl = useMemo(() => {
      return getThumbnailImage({ file: src, organizationId, templateId });
  }, [organizationId]);

  return (
    <Stack direction={'row'} spacing={2}>
      <Stack>
        <img
          className="src"
          style={styles.src}
          width={'75px'}
          height={'75px'}
          src={imageUrl}
        />
      </Stack>
      <Stack justifyContent={'center'}>
        {title ? <Typography>{title}</Typography> : null}
        {size ? (
          <Typography color={'GrayText'}>
            {(Number(size) / 1024 / 1024).toFixed(2)}MB
          </Typography>
        ) : null}
      </Stack>
    </Stack>
  );
};

export default MediaContent;
